// LoadingState.tsx — a calm, content-free waiting state (no spinner anxiety).
import { BrandMark } from './icons';

export function LoadingState({ label = 'Just a moment' }: { label?: string }) {
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: 'absolute',
        inset: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 16,
        padding: 24,
        textAlign: 'center',
      }}
    >
      <span className="rn-pulse" style={{ display: 'inline-flex' }}>
        <BrandMark size={42} />
      </span>
      <span
        style={{
          fontFamily: 'Fraunces, Georgia, serif',
          fontStyle: 'italic',
          fontWeight: 300,
          fontSize: 16,
          color: 'var(--ink-soft)',
        }}
      >
        {label}
      </span>
    </div>
  );
}
